<template>
  <div class="container mt-4">
    <TopNav
      :title="$t('GENERAL.LINK.CATEGORIES')"
      :showOpenMainNav="true"
      :icon="['far', 'folder-open']"
    >
      <NavItem
        icon="fal fa-plus"
        :text="$t('MEDIA_LIBRARY.LINK.ADD_CATEGORY')"
        @click.native="addCategory"
      />
    </TopNav>
    <div class="mt-4" v-show="!isLoading && !showEmpty">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">
              {{ $t('MEDIA_LIBRARY.LABEL.CATEGORY_NAME') }}
            </th>
            <th scope="col">
              {{ $t('MEDIA_LIBRARY.LABEL.TAGS') }}
            </th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <draggable :delay="draggableDelay" v-model="categories" tag="tbody">
          <tr v-for="category in categories" :key="category.category_id">
            <td class="h5 m-0 align-middle">
              {{ category.name }}
            </td>
            <td class="align-middle">
              <HMBadge
                class="tag"
                v-for="option in category.option_list"
                :key="option.id"
              >
                {{ option.name }}
              </HMBadge>
            </td>
            <HMTableButton
              v-confirm="{
                title: $t('MEDIA_LIBRARY.TITLE.DELETE_CATEGORY'),
                text: $t('MEDIA_LIBRARY.TEXT.THIS_IS_GOING_TO_BE_FINAL_PLEASE'),
                confirmButton: $t('MEDIA_LIBRARY.BUTTON.DELETE_CATEGORY'),
                confirm: () => deleteCategory(category),
              }"
              icon="trash-alt"
            />
            <HMTableButton @click="editCategory(category)" icon="pen" />
          </tr>
        </draggable>
      </table>
    </div>
    <div v-if="!isLoading && showEmpty" class="text-center">
      <HMEmpty
        image="empty-media-library"
        :title="$t('MEDIA_LIBRARY.TEXT.EMPTY_MEDIA_CATEGORIES_TITLE')"
        :description="
          $t('MEDIA_LIBRARY.TEXT.EMPTY_MEDIA_CATEGORIES_DESCRIPTION')
        "
      />
      <button
        @click="addCategory"
        type="button"
        name="button"
        class="btn btn-primary"
      >
        {{ $t('MEDIA_LIBRARY.LINK.ADD_CATEGORY') }}
      </button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import { draggableDelay } from '@/web/utils/draggable';
import { cloneDeep } from 'lodash';

import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import CategoryFormModal from '@/web/components/media-library/CategoryFormModal';

export default {
  components: {
    TopNav,
    NavItem,
    draggable,
  },
  data() {
    return {
      draggableDelay,
    };
  },
  computed: {
    categories: {
      get() {
        const categories = this.$store.state.mediaLibrary.categories;
        return cloneDeep(categories);
      },
      set(categories) {
        categories.forEach((category, index) => (category.position = index));
        this.$store.dispatch('mediaLibrary/reorderCategories', categories);
      },
    },
    isLoading() {
      return !this.$store.state.mediaLibrary?.categories;
    },
    showEmpty() {
      return !this.$store.state.mediaLibrary?.categories?.length;
    },
  },
  methods: {
    addCategory() {
      this.$modal.show(CategoryFormModal);
    },
    editCategory(category) {
      this.$modal.show(CategoryFormModal, { category });
    },
    deleteCategory({ category_id }) {
      return this.$store.dispatch('mediaLibrary/deleteCategory', category_id);
    },
  },
  mounted() {
    this.$store.dispatch('mediaLibrary/getCategories');
  },
};
</script>

<style lang="scss" scoped>
.icon-tr {
  position: relative;
}

.icon-tr-icon {
  position: absolute;
  left: 0;
  top: 0;
  width: 1.5rem;
  height: 1.5rem;
}

.tag {
  margin: 0.2rem;
}
</style>
